import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom'
import { Icon } from 'react-icons-kit'
import { ic_add_box } from 'react-icons-kit/md/ic_add_box'
import { ic_search } from 'react-icons-kit/md/ic_search'
import { ic_delete } from 'react-icons-kit/md/ic_delete'
import { ic_picture_as_pdf } from 'react-icons-kit/md/ic_picture_as_pdf'
import { ic_info } from 'react-icons-kit/md/ic_info'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

import NavBar from '../components/NavBar'
import TablePropAssoc from '../components/TablePropAssoc'
import FrDatePicker from '../components/FrDatePicker'
import FrTextInput from '../components/FrTextInput'
import FrSelect from '../components/FrSelect'
import UserOptions from '../components/UserOptions'
import FrLoading from '../components/FrLoading'
import FooterDelphus from '../components/FooterDelphus'
import download from 'downloadjs'


import api from '../services/api'
import { paramsToObject, formToObject, populateForm, objectToQueryString, isEmpty, getUserCode } from '../utils/functions'
import { mCPF } from '../utils/masks'

import './styles/DefaultMainScreen.css';
import './styles/Manut.css';

const swal = withReactContent(Swal)

function PropostaAssociado() {
    const [data, setData] = useState([])
    const [filter, setFilter] = useState({})
    const [filtered, setFiltered] = useState(false)
    const [comboVendedor, setComboVendedor] = useState([{ value: '', display: '' }])
    const [comboStatus, setComboStatus] = useState([{ display: 'A Confirmar', value: 'A' }, { display: 'Cancelada', value: 'C' }, { display: 'Emitida', value: 'E' }, , { display: 'Pendente de Assinatura', value: 'P' }, , { display: 'Assinada', value: 'S' }])
    const [comboPlanos, setComboPlanos] = useState([{ value: '', display: '' }])
    const [auth, setAuth] = useState(JSON.parse(localStorage['authKSA'] || JSON.stringify({ authenticated: false, user: 0 })));
    const [tipoGrupo, setTipoGrupo] = useState('')

    const columns = [
        { id: 'NUMERO_PROPOSTA', numeric: true, label: 'Nº Proposta', align: 'left', minWidth: 50 },
        { id: 'RAZAO_SOCIAL', numeric: false, label: 'Proponente', align: 'left', minWidth: 300 },
        { id: 'PLANO_DESCRICAO', numeric: true, label: 'Plano', align: 'left', minWidth: 200 },
        { id: 'PARCEIRO', numeric: true, label: 'Parceiro', align: 'left', minWidth: 200 },
        { id: 'NOMEVENDEDOR', numeric: true, label: 'Vendedor', align: 'left', minWidth: 200 },
        { id: 'STATUS', numeric: true, label: 'Status', align: 'left', minWidth: 200 },

    ]

    useEffect(() => {
        const fetchData = async () => {
            swal.fire({
                html: <FrLoading text="Carregando..." />,
                showConfirmButton: false,
                allowOutsideClick: false,
                allowEscapeKey: false
            })
            console.log(localStorage['authKSA'])
            setTipoGrupo(await api.getTipoGrupo(auth.user))
            setComboPlanos(await api.getComboData('planos'))
            setComboVendedor(await api.getComboData('vendedores', null, 'pk_uex=' + auth.user))

            let event = new Event('build');
            getData(event)
            swal.close()


            // const urlParams = new URLSearchParams(window.location.search);
            // let query = paramsToObject(urlParams)
            // setFilter(query)
            // populateForm(document.getElementById('searchForm'), query)
            // swal.close()
            // if (query.buscar === 'true') {
            //     let event = new Event('build');
            //     getData(event)
            // }
        }

        fetchData()
    }, [])

    function getData(e) {
        e.preventDefault()
        console.log()
        var formData = new FormData(document.getElementById('searchForm'))
        var queryObject = formToObject(formData)
        queryObject.buscar = true
        queryObject.pk_uex = auth.user;
        queryObject.tipo_grupo = auth.tipo_grupo;

        setFiltered(true)
        window.history.replaceState({ filtered: true }, 'filter', "/sistema/propostaAssociado?" + objectToQueryString(queryObject));
        swal.fire({
            html: <FrLoading text="Buscando dados..." />,
            showConfirmButton: false,
            allowOutsideClick: false,
            allowEscapeKey: false
        })
        api.get('/propostas', { params: queryObject }).then(r => {
            setData(r.data)
            swal.close()
        })
        // } else {
        // swal.fire('Nenhum filtro informado!', 'Informe ao menos um filtro para realizar a busca.', 'warning')
        // }
    }

    const handleChange = (e) => {
        const auxValues = { ...filter };
        switch (e.target.name) {
            case 'cpf':
                auxValues[e.target.name] = mCPF(e.target.value)
                break

            default:
                auxValues[e.target.name] = e.target.value;
                if (typeof (e.target.value) === 'string') auxValues[e.target.name] = e.target.value.toUpperCase()
                break
        }

        setFilter(auxValues);
    };

    function handlePdf(e) {
        e.preventDefault()
        var foundData = false
        swal.fire({
        html: <FrLoading text="Em Processamento..." />,
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false
        })
        api.get('/termo_adesao?id=0', {responseType: 'blob'}).then(r => {
        let name = 'proposta.pdf'  
        let type = 'applicaton/pdf'
        if (r.data.size>0){
            foundData=true
        }
        var blob = new Blob([r.data], {
            type: type
            });
            download(blob, name)
            swal.close()
        })
        setTimeout(() => {
        if(!foundData){
            swal.fire({
            title: 'Atenção!',
            text: "arquivo não foi encontrado!",
            icon: 'warning',
            })
        } else {
            swal.close()
        }
        }, 8000)
        // const url = api.backendUrl + '/api/termo_adesao?id=0';
        // var link = document.createElement("a");
        // link.setAttribute('download', 'proposta.pdf');
        // link.href = url;
        // document.body.appendChild(link);
        // link.click();
        // link.remove();
    }

    return (
        <div className="Manut">
            <NavBar />
            <div className="ManutContent">
                <div className="defaultHeader">
                    <h1>Propostas</h1>
                    <UserOptions />
                </div>
                <br />
                <div className="filtersDiv">
                    <form id="searchForm" onSubmit={getData}></form>
                </div>
                <br />
                <div className="tableDiv">
                    <TablePropAssoc propostas regName="propostas" columns={columns} searched={filtered} codeName="PK_PRP" page={'Propostas'} data={data} />
                </div>
                <FooterDelphus />
            </div>
        </div>
    );
}

export default PropostaAssociado;
